export default function Landing2Get() {
  return (
    <>
      <section className="land2-get-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="land2-get-details">
                <h3 className="heading gradiant-color">What You Get</h3>
                <span>Everything you need to manage your taxi business efficiently</span>
                <p>Boost your taxi operations with our advanced AI based taxi dispatch solution, seamlessly improving customer experience and enhancing driver efficiency. Here’s what you’ll get:</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
